module Environments {
    export var module = angular.module("EnvironmentsServiceModule", ["frends-utils", "ui.bootstrap"]);
    angular.module("EnvironmentsModule", ["ui.router", "frends-utils", "EnvironmentsServiceModule"])
        .run([
            "$rootScope", "$state", "$stateParams",
            function ($rootScope, $state, $stateParams) {
                // state and stateParams gets used in every controller.
                // Attaching it to rootScope means we don't need to explicitly inject them into every controller.
                $rootScope.$state = $state;
                $rootScope.$stateParams = $stateParams;
            }
        ])
        .config([
            "$stateProvider", "$urlRouterProvider", "$locationProvider", "$urlMatcherFactoryProvider",
            function ($stateProvider, $urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider) {

                // Removes trailing slash before hitting the stateProvider. The trailing slash makes ui-router think you are going to a child-state
                // For example, /Environment/ will direct you to 'Environment/:environmentName' with no environmentName parameter.
                $urlMatcherFactoryProvider.strictMode(false);


                // We don't allow users to directly go to the /agent route without specifying an agentName. It's just for maintaining state hierarchy.
                // The redirect shouldn't happen in the controller, though, because child states of /agent still depends on that controller.
                $urlRouterProvider.when("/Environment/:environmentName/:agentGroupName/agent", "/Environment/:environmentName");

                // Using push-state. No more ugly # in the URL for angular routes.
                $locationProvider.html5Mode(true);


                $stateProvider.state("environments", {
                    url: "/Environment",
                    templateUrl: "EnvironmentsListTemplate",
                    resolve: {
                        environments: [
                            "EnvironmentsService", function (environmentsService) {
                                // Doing this request here ensures that we synchronously execute controllers only after the request is complete.
                                // If the request is done directly in EnvironmentsListController, navigating directly to any child controller
                                // will result in executing the child controller without the data, because the request is async in the parent controller.
                                return environmentsService.populateEnvCache();
                            }
                        ]
                    },
                    controller: "EnvironmentsListController"
                })
                    .state("environments.new", {
                        url: "/newEnvironment",
                        templateUrl: "EnvironmentDetailsTemplate",
                        controller: "NewEnvironmentController"
                    })
                    .state("environments.detail", {
                        url: "/:environmentName",
                        templateUrl: "EnvironmentDetailsTemplate",
                        controller: "EnvironmentDetailsController"
                    })
                    .state("environments.agentGroup", {
                        url: "/:environmentName/:agentGroupName",
                        templateUrl: "AgentGroupDetailsTemplate",
                        controller: "AgentGroupDetailsController"
                    })
                    .state("environments.newAgentGroup", {
                        url: "/:environmentName/newAgentGroup",
                        templateUrl: "AgentGroupDetailsTemplate",
                        controller: "AgentGroupDetailsController"
                    })
                    .state("environments.agentGroup.agent", {
                        url: "/agent",
                        template: "<div ui-view></div>",
                        controller: "AgentController"
                    })
                    .state("environments.agentGroup.agent.new", {
                        url: "/newAgent",
                        templateUrl: "AgentEditTemplate",
                        controller: "NewAgentController",
                        params: {
                            isGateway: false
                        }
                    })
                    .state("environments.agentGroup.agent.detail", {
                        url: "/:agentName",
                        templateUrl: "AgentDetailsTemplate",
                        controller: "AgentDetailsController as ctrl"
                    })
                    .state("environments.agentGroup.agent.detail.processGuid", {
                        url: "/process/:processGuid",
                        templateUrl: "AgentDetailsTemplate",
                        controller: "AgentDetailsController as ctrl"
                    })
                    .state("environments.agentGroup.agent.edit", {
                        url: "/:agentName/edit",
                        templateUrl: "AgentEditTemplate",
                        controller: "AgentEditController"
                    });
            }
        ]);
}